
<div class="centered-container">
  <v-row align-center justify="center" class="centered-container">
    <v-card id="codeInsertion" class="elevation-3">
      <v-card-text>
        <h3 class="title">{{ $t("CODE_WELCOME") }}</h3>
        <p class="codeNotice">{{ $t("CODE_NOTICE") }}</p>
      </v-card-text>
      <v-card-text>
        <div
            v-for="(code, it) in codes"
            :key="it + '_' + codeImportCounter"
            class="codeContainer"
        >
          <v-text-field
              v-model="codes[it]"
              name="code"
              :label="$t('CODE_LABEL')"
              type="text"
              :success="valid[it]"
              :error="errors[it] != null"
              :error-messages="errors[it]"
              :disabled="isCodeFromStore(code)"
              ref="codeField"
              :class="{codeInput: true, deletable: true}"
              @input="onCodeChanged(it)"
          ></v-text-field>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                  class="hoverPointer"
                  v-show="it > 0 || codes.length > 1"
                  @click="removeCode(it)"
                  v-on="on"
              >close
              </v-icon>
              <v-icon
                class="hoverPointer"
                v-show="it === 0 && codes.length === 1 && codes[it] !== ''"
                v-on="on"
                @click="clearCode(it)"
              >close
              </v-icon>
            </template>
            <span>{{ $t("REMOVE_CODE") }}</span>
          </v-tooltip>
        </div>

        <div class="addCode" @click="addCode">

        </div>
      </v-card-text>
      <v-card-actions>
        <v-row align-center class="codeButtons">
          <v-col class="buttonContainer">
            <v-btn :disabled="!mayAddCode" @click="addCode">
              <v-icon>add</v-icon>
              {{ $t("BUTTON_OTHER_CODE") }}
            </v-btn>
          </v-col>
          <v-col class="buttonContainer">
            <v-btn
              v-if="this.committedCodes.length > 0 && this.codesInputMatchesSelection"
              color="primary"
              :disabled="! allCodesValid"
              @click="continueToNextStep()"
            >
              {{ $t("BUTTON_SUBMIT_CODE_UNMODIFIED") }}
            </v-btn>
            <div v-else>
              <Altcha v-model="altcha" :key="altchaKey"/>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-btn
                      v-if="committedCodes.length > 0 && !codesInputMatchesSelection"
                      color="primary"
                      :disabled="! maySubmit"
                      @click="start"
                    >
                      {{ $t("BUTTON_SUBMIT_CODE_MODIFIED") }}
                    </v-btn>
                    <v-btn
                      v-else
                      color="primary"
                      :disabled="! maySubmit"
                      @click="start"
                    >
                      {{ $t("BUTTON_SUBMIT_CODE") }}
                    </v-btn>
                  </div>
                </template>
                <span v-if="buttonTooltip">{{buttonTooltip}}</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-row>
</div>
